export default __webpack_public_path__ + "static/media/foto8.6e54cc52.jpg";